import React, { Fragment } from 'react';
import UserForm from './UserForm';
import { Breadcrumbs } from '../../../AbstractElements';

const UserFormPage = () => {
  return (
    <Fragment>
      <Breadcrumbs parent="Master Data" title="user" />
      <UserForm />
    </Fragment>
  );
};
export default UserFormPage;